// wsClient.js
let ws = null;
let listeners = new Set();
let reconnectTimer = null;
let pingInterval = null;
let lastConfig = null;

// Ping every 25 seconds to keep connection alive (most servers timeout at 30-60s)
const PING_INTERVAL = 25000;
// Reconnect after 3 seconds on disconnect
const RECONNECT_DELAY = 3000;

function startPing() {
  stopPing();
  pingInterval = setInterval(() => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      try {
        ws.send(JSON.stringify({ type: "ping", t: Date.now() }));
      } catch (e) {
        console.log("[ws] ping failed:", e.message);
      }
    }
  }, PING_INTERVAL);
}

function stopPing() {
  if (pingInterval) {
    clearInterval(pingInterval);
    pingInterval = null;
  }
}

export function ensureWS(url, token) {
  lastConfig = { url, token };

  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
    return ws;
  }

  ws = new WebSocket(url, token);

  ws.onopen = () => {
    console.log("[ws] singleton connected");
    startPing(); // Start keepalive pings
  };
  
  ws.onmessage = (ev) => listeners.forEach(fn => fn(ev));
  ws.onerror = (e) => console.log("[ws] singleton error", e);

  ws.onclose = (e) => {
    console.log("[ws] singleton closed, code:", e.code, "retrying in", RECONNECT_DELAY, "ms...");
    stopPing();
    clearTimeout(reconnectTimer);
    reconnectTimer = setTimeout(() => {
      ws = null;
      if (lastConfig) ensureWS(lastConfig.url, lastConfig.token);
    }, RECONNECT_DELAY);
  };

  return ws;
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// Force reconnect (useful when token changes)
export function forceReconnect() {
  stopPing();
  clearTimeout(reconnectTimer);
  if (ws) {
    try { ws.close(); } catch {}
  }
  ws = null;
  if (lastConfig) {
    ensureWS(lastConfig.url, lastConfig.token);
  }
}

// Check if connected
export function isConnected() {
  return ws && ws.readyState === WebSocket.OPEN;
}
